export const groupModelsByGroupName = (models) => {
    let groupedModels = [];
    let noGroupModels = { GroupName: 'no group', Models: [] };
    
    for (const model of models) {
        if (model.Playlists.length > 0) {
            if (model.Group) {
                const groupIndex = groupedModels.findIndex(group => group.GroupName === model.Group);
                if (groupIndex > -1) {
                    groupedModels[groupIndex].Models.push(model);
                } else {
                    groupedModels.push({
                        GroupName: model.Group,
                        Models:  [{ ...model }]
                    })
                }
            } else {
                noGroupModels.Models.push(model);
            }
        }
    }

    return {
        grouped: [ ...groupedModels ], 
        notGrouped: noGroupModels
    }
}